import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
interface LoadingScreenProps {
  onComplete: () => void;
}
export function LoadingScreen({
  onComplete
}: LoadingScreenProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 3000); // 3 seconds
    return () => clearTimeout(timer);
  }, [onComplete]);
  return <div className="relative w-full h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center overflow-hidden" data-id="element-46">
      {/* Animated background */}
      <div className="absolute inset-0 opacity-20" data-id="element-47">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl animate-pulse" data-id="element-48" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-pulse delay-1000" data-id="element-49" />
      </div>

      <div className="relative z-10 max-w-4xl px-8" data-id="element-50">
        {/* Loading spinner */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="flex justify-center mb-8" data-id="element-51">
          <div className="relative w-16 h-16" data-id="element-52">
            <div className="absolute inset-0 border-4 border-cyan-500/30 rounded-full" data-id="element-53" />
            <motion.div animate={{
            rotate: 360
          }} transition={{
            duration: 1,
            repeat: Infinity,
            ease: 'linear'
          }} className="absolute inset-0 border-4 border-transparent border-t-cyan-500 rounded-full" data-id="element-54" />
          </div>
        </motion.div>

        {/* Loading text */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="text-center text-white text-lg" data-id="element-55">
          Building your virtual showhome...
        </motion.p>
      </div>
    </div>;
}